export default __webpack_public_path__ + "static/Digitize-538d8c0e1bf466e578f8416679c12bc8.webp";